import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { CreateBase } from "react-admin";
import { grants } from "../../backoffice.access_control";
import { AccessDenied } from "../../misc/AccessDenied";
import { DialogCloseButton } from "../../misc/DialogCloseButton";
import { type DialogProps } from "../../misc/DialogProps";
import { AutoFormForm } from "../../resources/autoFormsResource";

export function AddAutoFormDialog(props: DialogProps & { drivingSchoolId: string }) {
  const { drivingSchoolId, onClose, open } = props;

  if (!grants.has("DrivingSchool:AutoForm:create")) {
    return <AccessDenied />;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Neues Auto-Formular</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <CreateBase
          resource="autoForms"
          mutationOptions={{
            onSuccess: () => {
              showSuccessToast("Auto-Formular erfolgreich erstellt.");
              onClose();
            },
            onError: (error: Error) => {
              handleError("Fehler beim Erstellen des Auto-Formulars.", error);
            },
          }}
          transform={(formValues) => ({
            ...formValues,
            drivingSchoolId,
            isForRegistration: Boolean(formValues.isForRegistration),
          })}
        >
          <AutoFormForm mode="create" />
        </CreateBase>
      </DialogContent>
    </Dialog>
  );
}
